import React, {createContext, useContext, useMemo, ReactNode} from 'react';
import {useAgentDrawer} from '../hooks/useAgentDrawer';

type ActiveView = 'chat' | 'library';

type AgentDrawerContextValue = {
	isOpen: boolean;
	activeView: ActiveView;
	inputValue: string;
	openDrawer: () => void;
	closeDrawer: () => void;
	setActiveView: (view: ActiveView) => void;
	setInputValue: (value: string) => void;
};

const AgentDrawerContext = createContext<AgentDrawerContextValue | null>(null);

type AgentDrawerProviderProps = {
	children: ReactNode;
};

export const AgentDrawerProvider = ({children}: AgentDrawerProviderProps): JSX.Element => {
	const {isOpen, activeView, openDrawer, closeDrawer, setActiveView} = useAgentDrawer();
	const [inputValue, setInputValue] = React.useState('');
	const value = useMemo(
		() => ({isOpen, activeView, openDrawer, closeDrawer, setActiveView, inputValue, setInputValue}),
		[isOpen, activeView, openDrawer, closeDrawer, setActiveView, inputValue, setInputValue]
	);

	return <AgentDrawerContext.Provider value={value}>{children}</AgentDrawerContext.Provider>;
};

export const useAgentDrawerContext = (): AgentDrawerContextValue => {
	const ctx = useContext(AgentDrawerContext);
	if (!ctx) throw new Error('useAgentDrawerContext must be used within AgentDrawerProvider');
	return ctx;
};
